import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { RxCrossCircled } from 'react-icons/rx';

function IdentityVerify() {
  return (
    <>
      <div className="bg-gray-100">
        <div className='w-[100%] h-2 bg-primarygreen rounded-r-full'>
        </div>
      </div>
      <div className="flex justify-center items-center w-[90%] md:w-[60%] xl:w-[30%] m-auto">
        <div className="mx-6 bg-white p-8 rounded-lg shadow-md my-10">
          <h2 className="text-2xl font-pop text-center font-bold mb-4">Identity verification</h2>
          <p className="text-black font-pop text-lg mb-2">Thank you, Liam! We’re just checking your details...</p>
          <p className="text-gray-600 font-pop mb-2">Our team verifies the information you provide. We will notify you via your email address when we have fully verified your information.</p>

          {/* <form> */}
          <div className="flex font-pop my-4 flex-col gap-2 py-2 px-4 border-l-4 border-primarygreen">
            <h4 className='font-semibold text-lg'>Your documents are being checked</h4>
            <p className='text-lightGrey'>It may take approximately 2 days</p>
          </div>

          <button className="my-4 w-full bg-green-500 hover:bg-transparent  hover:bg-white-500 font-semibold hover:text-black font-pop text-xl py-3 px-4 border border-black-500 hover:border-green-500 rounded-full  text-white animate__animated animate__backInUp ">
            <Link to={'/'}>
              Got It
            </Link>
          </button>
          {/* </form> */}
        </div>
      </div>
    </>
  );
}

export default IdentityVerify;
